export { OrderDetailsFallback } from './OrderDetailsFallback';
